export default __webpack_public_path__ + "static/media/devops.5538716c.png";